const $ = window.jQuery;

const Nav = {
	init() {
		var $burger = $(document).find('.burger button');
		if (!$burger.length) return;

		var $toggleBbutton = $(document).find('.toggle-button');

		// Toggle sub-menus
		$toggleBbutton.on('click', function () {
			$(this).parent().toggleClass('menu-collapsed');
			$(this).toggleClass('tgl-active');
		});

		$burger.on('click', function () {
			$(this).toggleClass('active');
			$('nav.main ').toggleClass('mobile-active');
			var $parentsSubMenus = $('#huvudmeny').find('.current-menu-item').parents('.sub-menu');
			$parentsSubMenus.prev().toggleClass('tgl-active');
			$parentsSubMenus.parent().toggleClass('menu-collapsed');
		});
	},
	initSideNav() {
		var $sidebarNav = $(document).find('#sortimentNav');
		if (!$sidebarNav.length) return;

		// Toggle sub-menus
		$sidebarNav.on('click', '.toggle-sub', function () {
			const icon = $(this).find('i');

			if (icon.hasClass('fa-plus')) {
				$(this).attr('aria-label', 'Dölj undermeny');
				icon.removeClass('fa-plus');
				icon.addClass('fa-minus');
				icon.parent().parent().addClass('current-page-parent');
				icon.parent().parent().addClass('current-page-item');
				$(this).addClass('active');
			} else {
				$(this).attr('aria-label', 'Visa undermeny');
				icon.removeClass('fa-minus');
				icon.addClass('fa-plus');
				icon.parent().parent().removeClass('current-page-parent');
				icon.parent().parent().removeClass('current-page-item');
				$(this).removeClass('active');
			}
		});
	},
};

export default Nav;
